import api from '@/api/api';
import store from '../../store/store';

const baseURL = process.env.VUE_APP_ROOT_API;

export const projetoService = {
  getProjeto,
  getItensProjeto,
  addItemProjeto,
  updateItemProjeto,
  deleteItemProjeto,
  getProjetosAtivos,
  getProjetoTags,
  addProjetoTag,
  deleteProjetoTag,
  getProjetoColaboradores,
  addProjetoColaborador,
  deleteProjetoColaborador,
  getProjetoAtividades,
  getProjetoAtividadesVinculos,
  getProjetoProjetosVinculos,
  addProjetoVinculo,
  deleteProjetoVinculo
}

function getProjeto(id) {
  return api.get(`projetos/${id}`);
}

function getProjetosAtivos() {
  const { IdColaborador } = store.getters.user;
  return api.get(`projetos?idResponsavel=${IdColaborador}&status=A&idSituacao=null`);
}

// Itens

function getItensProjeto(idProjeto) {
  return api.get(`itensprojetos/${idProjeto}`);
}

function addItemProjeto(item) {
  return api.post(`itensprojetos`, item);
}

function updateItemProjeto(item) {
  return api.put(`itensprojetos/${item.IdProjeto}/${item.IdItem}`, item);
}

function deleteItemProjeto(item) {
  let query = '';

  if (item.Atividade) {
    let idAtividade = item.Atividade.IdAtividade;
    query = `?idAtividade=${idAtividade}`;
  } else if (item.Projeto) {
    let idProjetoVinculo = item.Projeto.IdProjeto;
    query = `?idProjetoVinculo=${idProjetoVinculo}`;
  }

  return api.delete(`itensprojetos/${item.IdProjeto}/${item.IdItem}${query}`);
}

// Colaboradores

function getProjetoColaboradores(id) {
  return api.get(`projetoscolaboradores/${id}`);
}

function addProjetoColaborador(colaborador) {
  return api.post(`projetoscolaboradores`, colaborador);
}

function deleteProjetoColaborador(colaborador) {
  return api.delete(`projetoscolaboradores/${colaborador.IdProjeto}/${colaborador.IdColaborador}`);
}

// Tags

function getProjetoTags(id) {
  return api.get(`projetostags/${id}`);
}

function addProjetoTag(tag) {
  return api.post(`projetostags`, tag);
}

function deleteProjetoTag(tag) {
  return api.delete(`projetostags/${tag.IdProjeto}/${tag.IdTag}`);
}

// Atividades Vinculos

// @filtro
// Todas, Projeto ou Vinculadas
function getProjetoAtividades(idProjeto, filtro) {
  let query = '';

  if (filtro === 'Todas') {
    query = '&todas=true&vinculadas=false';
  } else if (filtro === 'Projeto') {
    query = '&todas=false&vinculadas=false';
  } else if (filtro === 'Vinculadas') {
    query = '&vinculadas=true';
  } else {
    query = '&todas=true&vinculadas=false';
  }

  return api.get(`atividades?idProjeto=${idProjeto}${query}`);
}

function getProjetoAtividadesVinculos(idEmpresa = 1, idProjeto) {
  return api.get(`atividadesvinculos/${idEmpresa}/${idProjeto}`);
}

// Projetos Vinculos

function getProjetoProjetosVinculos(idProjeto) {
  return api.get(`projetosvinculos/${idProjeto}`);
}

function addProjetoVinculo(itemProjeto) {
  return api.post('projetosvinculos', itemProjeto);
}

function deleteProjetoVinculo(projetoVinculo) {
  return api.delete(`projetosvinculos/${projetoVinculo.IdProjeto}/${projetoVinculo.IdProjetoVinculo}?projeto=${projetoVinculo.Projeto}`);
}